import Translator from "../../../requests/apa/Translator";
import { countriesTabs } from "./constants";

export const getCountriesTabs = () => countriesTabs.map(tab => {
    return{
        id: Translator.get(tab),
        label: Translator.get(tab)
    }
}) 


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/utils.js